import ComparisonSlider from 'comparison-slider';
const comparisonSlider = new ComparisonSlider();

export class TabHolderBlock {
    private tabs: JQuery;
    private defaultTabs: JQuery;
    private trackedImages: Array<string>;
    constructor() {
        this.defaultTabs = $(".tabholder-links li:first-child a");
        this.tabs = $('.tabholder-links li a');
        this.trackedImages = new Array();
        this.init();
        //get first tab as default
        this.defaultTabs.click();
    }

    trackCompareEvent(eventName: string, imageId: string) {
        if (this.trackedImages.indexOf(imageId, 0) < 0) {
            if ((window as any)._hsq != null) {
                (window as any)._hsq.push(["trackEvent", {
                id: eventName,
                value: 1
            }]);
            }
            this.trackedImages.push(imageId);
        }
        else {
            
        }
    }

    private init() {
        this.tabs.each((i, e) => {
            var tab = $(e);
            tab.on('click', (event:Event) => {
                event.preventDefault();
                tab.parent().siblings().children("a").removeClass("selected");
                tab.addClass("selected");
                $("#".concat(tab.data("target"))).load(tab.data("href").concat(" article"), () => {
                    var ajaxComparisonSlider = new ComparisonSlider();
                    var eventName = $(ajaxComparisonSlider.$el).data("event-name");
                    var imageId = ajaxComparisonSlider.$el.id;
                    ajaxComparisonSlider.$el.addEventListener('mousedown', () => { this.trackCompareEvent(eventName, imageId ) });
                    ajaxComparisonSlider.$el.addEventListener('touchstart', () => { this.trackCompareEvent(eventName, imageId ) });
                });
            });
        });
        
    }

    
}

//var tabHolderBlock = new TabHolderBlock();